module.exports = __webpack_public_path__ + "img/Asset40@300x.png";